import { SlicePipe } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { PopoverDirective } from "@kno2/common/directives";
import { FaxPipe } from "@kno2/common/pipes";

@Component({
    selector: "kno2-multi-address-snippet",
    imports: [PopoverDirective, SlicePipe, FaxPipe],
    templateUrl: "./multi-address-snippet.component.html"
})
export class MultiAddressSnippetComponent {
    public addressString = input<string | string[]>();
    public splitOnChar = input<string>(";");
    public delimiter = input<string>(", ");
    public limit = input<number>(3);

    protected addresses = computed(() => {
        const addresses = this.addressString();
        return Array.isArray(addresses) ? addresses : addresses.split(this.splitOnChar());
    });
    protected popover = computed(() =>
        this.addresses()
            .map((address) => `<div class="hover-address">${address}</div>`)
            .join("")
    );
}
